import type { Actor } from "@/types/work";

export const actors: Actor[] = [
  {
    id: "a1",
    name: "林知远",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20studio%20portrait%20of%20a%20calm%20middle-aged%20east%20asian%20man%20with%20short%20dark%20hair%2C%20neutral%20warm%20beige%20background%2C%20soft%20single-source%20lighting%2C%20serious%20thoughtful%20expression%2C%20editorial%20photography%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=400&height=400&seq=actor-a1&orientation=squarish",
    bio: "实力派影视演员，以细腻克制的表演风格著称，擅长塑造身处道德灰地带的复杂角色。代表作横跨悬疑、都市与犯罪题材，多次获得年度最佳男主角提名。",
    representative: ["夜航之港", "城中之城", "迷雾档案"],
  },
  {
    id: "a2",
    name: "苏晴",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20studio%20portrait%20of%20a%20graceful%20east%20asian%20woman%20with%20long%20straight%20black%20hair%2C%20soft%20warm%20neutral%20background%2C%20gentle%20melancholic%20expression%2C%20editorial%20beauty%20photography%2C%20soft%20diffused%20lighting%2C%20high%20detail%20film%20grain&width=400&height=400&seq=actor-a2&orientation=squarish",
    bio: "兼具文艺气质与银幕张力的女演员，从独立电影出道，逐渐成为都市情感题材的首选面孔。表演自然富有层次，被观众称为“最会演沉默的人”。",
    representative: ["尘埃里的花", "十二楼的月亮", "风起时"],
  },
  {
    id: "a3",
    name: "陆则明",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20studio%20portrait%20of%20a%20sharp-featured%20east%20asian%20man%20in%20his%20thirties%2C%20dark%20neutral%20background%2C%20intense%20focused%20gaze%2C%20dramatic%20side%20lighting%2C%20editorial%20photography%2C%20high%20detail%20contrast%2C%20moody%20tone&width=400&height=400&seq=actor-a3&orientation=squarish",
    bio: "以犯罪与权谋题材见长的男演员，气场强烈，台词功底扎实。善于在高压情境下呈现人物内心的裂痕，被业内誉为“情绪爆破点”。",
    representative: ["长夜将明", "落雪听禅"],
  },
  {
    id: "a4",
    name: "温语彤",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20studio%20portrait%20of%20an%20elegant%20east%20asian%20woman%20with%20tied-up%20hair%2C%20soft%20muted%20grey%20background%2C%20composed%20confident%20expression%2C%20editorial%20photography%2C%20soft%20window%20lighting%2C%20subtle%20film%20grain%2C%20high%20detail&width=400&height=400&seq=actor-a4&orientation=squarish",
    bio: "气质清冷、戏路宽广的女演员，从古装到都市题材皆能驾驭。擅长用眼神与微表情完成情绪递进，是导演眼中“不需要台词也能演戏”的演员。",
    representative: ["落雪听禅", "长夜将明", "花开半夏"],
  },
  {
    id: "a5",
    name: "顾寒声",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20studio%20portrait%20of%20a%20young%20east%20asian%20man%20with%20messy%20dark%20hair%2C%20warm%20amber%20studio%20background%2C%20brooding%20artistic%20expression%2C%20editorial%20photography%2C%20dramatic%20rim%20lighting%2C%20high%20detail%2C%20cinematic%20mood&width=400&height=400&seq=actor-a5&orientation=squarish",
    bio: "新生代演员中的“文艺片担当”，气质疏离而独特。因在奇幻与都市作品中的反差演出迅速走红，被认为是最具作者电影潜质的年轻面孔。",
    representative: ["山海谣", "十二楼的月亮", "江湖再见"],
  },
  {
    id: "a6",
    name: "江晚照",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20studio%20portrait%20of%20a%20bright%20east%20asian%20woman%20with%20wavy%20hair%2C%20soft%20cream%20background%2C%20warm%20open%20smile%2C%20editorial%20beauty%20photography%2C%20soft%20even%20lighting%2C%20high%20detail%2C%20natural%20tone&width=400&height=400&seq=actor-a6&orientation=squarish",
    bio: "国民度颇高的女演员，气质明快、亲和力强。古装造型尤受观众喜爱，擅长演绎外柔内刚的女性角色，同时兼具喜剧节奏感。",
    representative: ["山海谣", "城中之城", "长安旧梦"],
  },
  {
    id: "a7",
    name: "沈砚",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20studio%20portrait%20of%20a%20refined%20east%20asian%20man%20with%20neat%20short%20hair%2C%20deep%20blue-grey%20background%2C%20quiet%20introspective%20expression%2C%20editorial%20photography%2C%20soft%20cool%20lighting%2C%20high%20detail%20film%20grain&width=400&height=400&seq=actor-a7&orientation=squarish",
    bio: "科班出身的实力男演员，戏剧舞台经历丰富。表演收放自如，在罪案与家庭题材中均展现出极强的现实质感，是近年口碑剧的常客。",
    representative: ["尘埃里的花", "暗涌", "花开半夏"],
  },
  {
    id: "a8",
    name: "白亦然",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20studio%20portrait%20of%20a%20youthful%20east%20asian%20man%20with%20tousled%20hair%2C%20muted%20olive%20background%2C%20gentle%20candid%20expression%2C%20editorial%20photography%2C%20natural%20window%20lighting%2C%20high%20detail%2C%20warm%20neutral%20tone&width=400&height=400&seq=actor-a8&orientation=squarish",
    bio: "从青春题材走入大众视野的男演员，气质干净、节奏细腻。近年来不断挑战年代与黑色幽默题材，展现出超越年龄的表演控制力。",
    representative: ["归途列车", "少年游", "无名之辈"],
  },
  {
    id: "a9",
    name: "韩沐",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20studio%20portrait%20of%20a%20tall%20east%20asian%20young%20man%20with%20straight%20dark%20hair%2C%20soft%20grey%20background%2C%20composed%20calm%20expression%2C%20editorial%20photography%2C%20soft%20studio%20lighting%2C%20high%20detail%2C%20cool%20neutral%20tone&width=400&height=400&seq=actor-a9&orientation=squarish",
    bio: "外形与演技兼备的青年演员，戏路从青春阳光延伸至科幻硬核。为角色进行大量体能训练的敬业态度广受好评，被视为类型片的潜力新星。",
    representative: ["归途列车", "少年游", "深海回声"],
  },
  {
    id: "a10",
    name: "唐映雪",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20studio%20portrait%20of%20a%20striking%20east%20asian%20woman%20with%20sleek%20hair%2C%20deep%20burgundy%20background%2C%20confident%20cool%20gaze%2C%20editorial%20beauty%20photography%2C%20dramatic%20lighting%2C%20high%20detail%20film%20grain%2C%20elegant%20tone&width=400&height=400&seq=actor-a10&orientation=squarish",
    bio: "跨语言发展的女演员，兼具国际视野与东方气质。擅长科幻、爱情与灾难题材中高强度的情绪表达，是近年国际合作项目的常驻面孔。",
    representative: ["雨中告别", "潮汐之下", "星轨旅人"],
  },
  {
    id: "a11",
    name: "程亦航",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20studio%20portrait%20of%20a%20mature%20east%20asian%20man%20with%20grey-flecked%20hair%2C%20deep%20charcoal%20background%2C%20steady%20authoritative%20expression%2C%20editorial%20photography%2C%20dramatic%20low-key%20lighting%2C%20high%20detail%2C%20cinematic%20tone&width=400&height=400&seq=actor-a11&orientation=squarish",
    bio: "观众熟悉的中生代演员，气场沉稳、极具说服力。近年多出演灾难与科幻题材中的关键决策者，被戏称为“最后一分钟救场专业户”。",
    representative: ["雨中告别", "潮汐之下", "极地航线"],
  },
  {
    id: "a12",
    name: "谢知微",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20studio%20portrait%20of%20an%20elegant%20east%20asian%20woman%20with%20soft%20updo%20hair%2C%20soft%20taupe%20background%2C%20mysterious%20reserved%20expression%2C%20editorial%20beauty%20photography%2C%20soft%20directional%20lighting%2C%20high%20detail%2C%20sophisticated%20tone&width=400&height=400&seq=actor-a12&orientation=squarish",
    bio: "以悬疑与惊悚题材崭露头角的女演员，善于营造不安与神秘感。表演节制而精准，近年逐渐拓展至文艺爱情与罪案剧领域。",
    representative: ["雾都疑影", "暗涌", "风起时"],
  },
  {
    id: "a13",
    name: "罗子骁",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20studio%20portrait%20of%20a%20rugged%20east%20asian%20man%20with%20short%20cropped%20hair%2C%20dark%20slate%20background%2C%20tough%20determined%20expression%2C%20editorial%20photography%2C%20hard%20directional%20lighting%2C%20high%20detail%20contrast%2C%20action%20hero%20tone&width=400&height=400&seq=actor-a13&orientation=squarish",
    bio: "动作题材的坚实代表，身形利落、打戏亲力亲为。从业多年塑造了众多硬汉与侠客形象，同时也不断尝试武侠与历史剧中的厚重角色。",
    representative: ["逆光而行", "长安旧梦", "江湖再见"],
  },
  {
    id: "a14",
    name: "宁怀",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20studio%20portrait%20of%20a%20serene%20east%20asian%20young%20man%20with%20soft%20hair%2C%20muted%20slate%20blue%20background%2C%20dreamy%20distant%20expression%2C%20editorial%20photography%2C%20soft%20cool%20lighting%2C%20high%20detail%2C%20ethereal%20tone&width=400&height=400&seq=actor-a14&orientation=squarish",
    bio: "气质独特的青年演员，擅长诠释孤独而敏感的科幻角色。台词不多却极具存在感，是新一代导演偏爱的“氛围型”表演者。",
    representative: ["星轨旅人", "深海回声"],
  },
  {
    id: "a15",
    name: "蒋南嘉",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20studio%20portrait%20of%20a%20warm%20east%20asian%20woman%20with%20shoulder-length%20hair%2C%20soft%20beige%20background%2C%20reassuring%20smile%2C%20editorial%20beauty%20photography%2C%20soft%20even%20lighting%2C%20high%20detail%2C%20natural%20tone&width=400&height=400&seq=actor-a15&orientation=squarish",
    bio: "实力与人气兼具的女演员，擅长演绎坚韧温柔的女性形象。在灾难与年代题材中表现稳定，多次以“最催泪表演”登上社交话题榜。",
    representative: ["逆光而行", "群山回响", "极地航线"],
  },
  {
    id: "a16",
    name: "段清和",
    avatar:
      "https://readdy.ai/api/search-image?query=cinematic%20studio%20portrait%20of%20a%20seasoned%20east%20asian%20man%20with%20greying%20temples%2C%20muted%20brown%20background%2C%20weathered%20wise%20expression%2C%20editorial%20photography%2C%20soft%20warm%20lighting%2C%20high%20detail%2C%20character%20actor%20tone&width=400&height=400&seq=actor-a16&orientation=squarish",
    bio: "资深性格演员，被誉为“黄金配角”。无论正剧还是黑色幽默都能精准落地，近年因年代剧与罪案剧中极具分量的表演被更多观众记住。",
    representative: ["群山回响", "无名之辈", "雾都疑影"],
  },
];